import { apiWrapper } from "@/services/api";

export const purchaseComplete = async (params) => {
  try {
    const response = await apiWrapper("POST", "sbps/purchase-complete", params);
    console.log("purchaseComplete::reponse", JSON.stringify(response.data));

    return response.data;
  } catch (err) {
    console.log('ERROR"" purchaseComplete():', err);
    throw err;
  }
};
